import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";

function wireUpEventHandler(handlerName, apiConnector, handlerParam) {
  if (handlerParam) {
    // Passes a 'next' parameter which allows a handler to work as
    // middleware for a connector
    if (apiConnector) {
      var next = apiConnector[handlerName].bind(apiConnector);
      return function () {
        for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }

        return handlerParam.apply(void 0, params.concat([next]));
      };
    }

    return handlerParam;
  }

  if (apiConnector && apiConnector[handlerName]) return apiConnector[handlerName].bind(apiConnector);
  return function () {
    throw "No ".concat(handlerName, " handler provided and no Connector provided. You must configure one or the other.");
  };
}
/*
 * This class encapsulates the logic for Events. Events are events that occur
 * within Search UI that require integration with an external service to
 * either fetch / search for data, or notify analytics services of interesting
 * events that occur within a UI.
 *
 * Handlers for these events can either be passed directly, or by providing
 * an API Connector. The events that are passed directly can also be used
 * to override or proxy handlers provided by API Connectors.
 */


var Events = /*#__PURE__*/_createClass(function Events() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      apiConnector = _ref.apiConnector,
      onSearch = _ref.onSearch,
      onAutocomplete = _ref.onAutocomplete,
      onResultClick = _ref.onResultClick,
      onAutocompleteResultClick = _ref.onAutocompleteResultClick;

  _classCallCheck(this, Events);

  this.search = wireUpEventHandler("onSearch", apiConnector, onSearch);
  this.autocomplete = wireUpEventHandler("onAutocomplete", apiConnector, onAutocomplete);
  this.resultClick = wireUpEventHandler("onResultClick", apiConnector, onResultClick);
  this.autocompleteResultClick = wireUpEventHandler("onAutocompleteResultClick", apiConnector, onAutocompleteResultClick);
});

export { Events as default };